export default "__VITE_ASSET__DfsBAZYx__"